import { useState, useEffect } from "react";
import { Smartphone, Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import api from "@/lib/api";

export const MyPhoneCard = () => {
  const [d, setD] = useState(null);
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/api/auth/me/phone").then(r => { setD(r.data); setPhone(r.data.phone || ""); }).catch(() => {}); }, []);
  const save = async (optOut = d.sms_opt_out) => {
    setBusy(true);
    try { const { data } = await api.put("/api/auth/me/phone", { phone, sms_opt_out: optOut }); setD(x => ({ ...x, ...data })); toast.success(data.message); }
    catch (e) { toast.error(e.response?.data?.detail || "Couldn't save"); } finally { setBusy(false); }
  };
  if (!d) return null;
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 shadow-sm mb-4" data-testid="my-phone-card">
      <div className="flex items-center gap-2 mb-1">
        <Smartphone className="w-5 h-5 text-blue-600" /><h3 className="font-semibold text-slate-900 flex-1">Text me meeting reminders</h3>
        <Switch checked={!d.sms_opt_out} disabled={busy} onCheckedChange={(on) => save(!on)} data-testid="my-phone-sms-switch" />
      </div>
      <p className="text-sm text-slate-500 mb-3">We'll text a reminder 1 hour before and a one-tap Join link 15 minutes before each meeting. Standard message rates may apply.</p>
      <div className="flex gap-2 max-w-md">
        <Input type="tel" inputMode="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder="Mobile number, e.g. (555) 123-4567" data-testid="my-phone-input" />
        <button onClick={() => save()} disabled={busy || phone === (d.phone || "")} className="bg-blue-600 disabled:opacity-50 text-white px-4 rounded-lg text-sm font-semibold flex items-center gap-1" data-testid="my-phone-save-btn">{busy && <Loader2 className="w-4 h-4 animate-spin" />}Save</button>
      </div>
      {!d.phone && d.on_file && <p className="text-xs text-slate-400 mt-2" data-testid="my-phone-on-file">We currently text {d.on_file} — save a number to change it.</p>}
    </div>
  );
};
